<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <layout-no-padding>
          <go-back></go-back>
          <page-title :routeProps="routeProps"></page-title>
        </layout-no-padding>

        <!-- <div class="title">Vehicle Types</div> -->
        <v-btn flat color="grey" @click="toggleView()">
          <v-icon left v-if="listView">list</v-icon>
          <v-icon left v-else>view_module</v-icon>View
        </v-btn>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm4 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
      </layout-no-padding>

      <v-dialog
        v-model="addVehicleTypeDialog"
        max-width="500px"
        @keydown.esc="addVehicleTypeDialog = false"
        v-if="userAuthClass"
      >
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-vehicleType" slot="activator">
          <v-icon dark>add</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-vehicleType @close="addVehicleTypeDialog = false"></add-vehicleType>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleService from "@/services/requests/vehicleService";
import AddVehicleType from "@/components/vehicleTypes/addVehicleType";
import RouteProps from "@/services/mixins/routeProps";
import getVehicleTypes from "@/services/mixins/getMasterFiles/getVehicleTypes";
export default {
  mixins: [RouteProps, getVehicleTypes],
  data() {
    return {
      addVehicleTypeDialog: false,
      showDetails: false
    };
  },
  methods: {
    toggleView() {
      this.listView = !this.listView;
    },
    sortVehicleTypes(path1, path2) {
      return this.vehicleTypes.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1;
        } else {
          return 1;
        }
      });
    }
  },
  computed: {
    contractorObj() {
      if (!!this.contractor) {
        return this.getObjByPrimaryId(this.contractor, this.contractors);
      } else {
        return null;
      }
    },
    filterBy: Store.getSet({ store: "vehicleTypes", prop: "filterBy" }),
    listView: Store.getSet({ store: "vehicleTypes", prop: "listView" })
  },
  components: {
    AddVehicleType
  }
};
</script>

<style scoped>
.overlap-fab-vehicleType {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
